import { useQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

interface Insight {
  site: string;
  onboarding_rate: number;
  session_count: number;
}

interface InsightsResponse {
  onboarding_rate: number;
  session_count: number;
  recent_sessions_count: number;
  insights: Insight[];
}

export default function useTeamLeadInsights() {
  return useQuery<InsightsResponse>({
    queryKey: [APIKey.TEAM_LEAD_INSIGHTS],
    queryFn: () => baseFetcher(`${apiRoutes.teamLeadInsights()}?days=30`),
  });
}
